export const MAP_STYLE = {
  street: "mapbox://styles/mapbox/standard",
  satellite: "mapbox://styles/mapbox/standard-satellite",
};

export const MARKER_LAYER_ID = "marker-circle-layer";
export const CIRCLE_LAYER_FILL_ID = "circle-fill";
export const CIRCLE_LAYER_OUTLINE_ID = "circle-outline";

export const BIN_TO_TEXT_COLOR = {
  Low: "#1b964f",
  Medium: "#f1a90f",
  High: "#E74C3C",
};

export const FIRE_HAZARD_COLOR_STOPS = [
  [0.05, "#9efc9c"],
  [0.1, "#93fb5b"],
  [0.2, "#edf42a"],
  [0.3, "#fabe6b"],
  [0.4, "#ea9c0b"],
  [0.5, "#fb6a6a"],
  [0.6, "#e60a0a"],
  [0.7, "#ab0707"],
  [0.8, "#6d0303"],
  [0.9, "#000000"],
];
